module.exports = __webpack_public_path__ + "static/media/big-login-bottom-wave.86cdd3d4.svg";